module.exports = __webpack_public_path__ + "img/i_bee-times.26022600.png";